<template>
  <v-card flat color="white" class="absolute-right custom-font-regular text-xs-right">
    <div v-if="loadingPresentations">
      <span class="pr-2 green--text">Cargando Presentaciones</span>
      <v-progress-circular indeterminate color="green" width="2" size="16"></v-progress-circular>
    </div>
    <div v-if="loadingDocuments">
      <span class="pr-2 red--text">Cargando Documentos</span>
      <v-progress-circular indeterminate color="red lighten-2" width="2" size="16"></v-progress-circular>
    </div>
    <div v-if="loadingEvents">
      <span class="pr-2 blue--text">Cargando Eventos</span>
      <v-progress-circular indeterminate color="primary" width="2" size="16"></v-progress-circular>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    loadingEvents: Boolean,
    loadingDocuments: Boolean,
    loadingPresentations: Boolean
  }
}
</script>

<style scoped>
.absolute-right {
  position: absolute;
  right: 10px;
  top: 2px;
  z-index: 1;
}
</style>
